import { render, staticRenderFns } from "./ExUserAccessBadge.vue?vue&type=template&id=7b628fc4"
import script from "./ExUserAccessBadge.vue?vue&type=script&lang=js"
export * from "./ExUserAccessBadge.vue?vue&type=script&lang=js"
import style0 from "./ExUserAccessBadge.vue?vue&type=style&index=0&id=7b628fc4&prod&lang=css"


/* normalize component */
import normalizer from "!../../admin/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports